import React, { Component } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faPause,
  faPlay,
  faVolumeDown,
  faVolumeUp,
} from "@fortawesome/free-solid-svg-icons";

class MusicPlayer extends Component {
  constructor(props) {
    super(props);
    this.state = {
      isPlaying: false,
      currentTime: 0,
      duration: 0,
      volume: 0.5, // Initial volume
      setReduxVolume: null,
    };
    this.index = props.index;
    this.name = props.name;
    this.url = props.file;
    this.isActive = props.isActive;
    this.showVolume = props.showVolume; // Added showVolume prop
    this.setReduxVolume = props.setReduxVolume; // store volume in the redux
    this.currentVolume = props.currentVolume; // store volume in the redux
    this.audioRef = React.createRef();
  }

  componentDidMount() {
    this.setState({
      volume: this.props.currentVolume || 0.5,
    });
  }

  render() {
    const { isPlaying, currentTime, duration, volume } = this.state;
    const { showVolume } = this.props; // Extract showVolume prop

    return (
      <div
        key={this.index}
        className={`relative w-full h-20 text-xs rounded flex flex-col justify-center items-center cursor-pointer overflow-hidden ${
          this.props.className || ""
        }`}
        onMouseLeave={this.stopPlayback}
      >
        <img
          className={`${
            this.isActive
              ? "border-[1.5px] border-solid border-vb-border"
              : "border border-gray-400"
          } p-2 rounded-lg hover:shadow-xl`}
          alt=""
          src={`/tool/dashboard/static/images/icons/tools/${
            this.isActive ? "active-bg-music" : "music-item-bg"
          }.svg`}
        />
        <div
          className="absolute bottom-6 left-4 space-x-2 "
          onClick={this.togglePlayback}
        >
          {isPlaying ? (
            <FontAwesomeIcon icon={faPause} />
          ) : (
            <FontAwesomeIcon icon={faPlay} />
          )}
          <span className="text-xss">{`${currentTime.toFixed(
            2
          )}s / ${duration.toFixed(2)}s`}</span>
        </div>

        <audio
          ref={this.audioRef}
          src={this.url}
          onTimeUpdate={this.updateTime}
          onLoadedMetadata={this.setDuration}
          volume={volume} // Set volume here
        />

        {/* Render volume slider if showVolume prop is true */}
        {showVolume && (
          <div className="flex items-center space-x-2">
            <FontAwesomeIcon icon={faVolumeDown} />
            <input
              type="range"
              min="0"
              max="1"
              step="0.01"
              value={volume}
              onChange={this.handleVolumeChange}
            />
            <FontAwesomeIcon icon={faVolumeUp} />
          </div>
        )}

        <div
          style={{ textWrap: "nowrap" }}
          className="w-full text-center text-nowrap"
        >
          {this.name}
        </div>
      </div>
    );
  }

  handleVolumeChange = (e) => {
    const { setReduxVolume } = this.props;
    const newVolume = parseFloat(e.target.value);
    this.setState({ volume: newVolume });
    const audio = this.audioRef.current;
    if (audio) {
      if (setReduxVolume) {
        setReduxVolume(newVolume);
      }
      audio.volume = newVolume;
    }
  };

  togglePlayback = (e) => {
    e.preventDefault();
    e.stopPropagation();
    const audio = this.audioRef.current;
    if (audio.paused) {
      audio.play();
      this.setState({ isPlaying: true });
    } else {
      audio.pause();
      this.setState({ isPlaying: false });
    }
  };

  stopPlayback = () => {
    const audio = this.audioRef.current;
    audio.pause();
    audio.currentTime = 0;
    this.setState({ isPlaying: false });
  };

  updateTime = () => {
    const audio = this.audioRef.current;
    this.setState({ currentTime: audio.currentTime });
  };

  setDuration = () => {
    const audio = this.audioRef.current;
    if (audio) this.setState({ duration: audio.duration });
  };
}

export default MusicPlayer;
